import { Outlet } from "react-router";
import { UserProvider } from "./context/useAuth";
import "../src/styles/App.css";
{/**/}
function App() {
    return (
        <>
            <UserProvider>
                <Outlet />
            </UserProvider>
        </>
    );
}

export default App;
